export default __webpack_public_path__ + "static/media/cocaLegal.aebc6c35.png";